module.exports = __webpack_public_path__ + "static/media/savio12.092f59ee.jpg";